import React from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DataUsageOutlinedIcon from '@mui/icons-material/DataUsageOutlined';
import HomePage from '../../pages/HomePage/HomePage';
import ManualUpload from '../../pages/ManualUpload/ManualUpload';
import PortfolioMasterData from '../../pages/PortfolioMasterData/PortfolioMasterData';
import CycleTrigger from '../../pages/CycleTrigger/CycleTrigger';
import PortfolioDetailView from '../../pages/PortfolioDetailView/PortfolioDetailView';
import Calendar from '../../pages/Calendar/Calendar';
import DecisionMakingRules from '../../pages/DecisionMakingRules/DecisionMakingRules';
import { ReactComponent as ReadinessIcon } from '../../assests/images/readiness.svg';
import { ReactComponent as CycleAnalyticsIcon } from '../../assests/images/cycleanalytics.svg';
import { ReactComponent as AlignmentAndAction } from '../../assests/images/alignmentandaction.svg';
import FeedbackCollation from '../../pages/FeedbackCollation/FeedbackCollation';
import DecisionMakingCentral from '../../pages/DecisionMakingCentral/DecisionMakingCentral';
import CycleActionSummary from '../../pages/CycleActionSummary/CycleActionSummary';
import SetupTeam from '../../pages/SetupTeam/index';
import { TPO_ADMIN, CORE_USER, GENERAL_USER } from '../../utils/Constants';
import CheckItems from '../../pages/PortfolioMasterData/CheckItems';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import PortfolioHealth from '../../pages/PortfolioMasterData/PortfolioHealth';
import { CalendarTodayOutlined, GroupOutlined } from '@mui/icons-material';
import NewHomePage from '../../pages/HomePage/HomePageV2';
/**
 * Central routes and page component for the application
 *
 * Please define you pages along with nested pages below .
 * Anything mentioned here will be present on Navbar and Routes.js file
 *
 * @param allowedUserScope : User's who can access this page
 * @param allowedBU : Keep "ALL" if all market have access to page/feature , else mention list of BU/market
 * @author [Neeshu]
 */

const pages = [
  {
    pageName: 'Home Page',
    path: '/home',
    icon: <HomeOutlinedIcon sx={{ marginLeft: -0.3, width: 26, height: 26 }} />,
    allowedUserScope: [TPO_ADMIN, CORE_USER, GENERAL_USER],
    allowedBU: ['ALL'],
    pageComponent: <NewHomePage />
  },
  {
    pageName: 'Portfolio Health',
    path: '/portfolio/portfolio-health',
    icon: <FavoriteBorderOutlinedIcon sx={{ marginLeft: -0.3, width: 26, height: 26 }} />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    pageComponent: <PortfolioHealth />
  },
  {
    pageName: 'Cycle Landing',
    path: '/cycle-landing', //"/portfolio",
    icon: <DataUsageOutlinedIcon sx={{ width: 22, height: 22 }} />,
    allowedUserScope: [TPO_ADMIN, CORE_USER, GENERAL_USER],
    allowedBU: ['ALL'],
    pageComponent: <HomePage />
  },
  {
    pageName: 'Calendar Cadence',
    path: '/readiness/calendar',
    icon: <CalendarTodayOutlined sx={{ width: 22, height: 22 }} />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    pageComponent: <Calendar />
  },
  {
    pageName: 'Readiness',
    icon: <ReadinessIcon />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    subPages: [
      {
        pageName: 'PO Manual Data Upload',
        path: '/upload',
        allowedUserScope: [TPO_ADMIN, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <ManualUpload />
      },
      {
        pageName: 'Portfolio Master Data',
        path: '/portfolio/master-data',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioMasterData />
      },
      {
        pageName: 'Review Items',
        path: '/portfolio/check-items',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <CheckItems />,
        disabled: true,
        hidden: true
      },
      {
        pageName: 'Decision Making Rules',
        path: '/readiness/decision-making-rules',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <DecisionMakingRules />,
        disabled: true
      },
      // {
      //   pageName: 'Portfolio Metrics Master',
      //   path: 'cycle-analytics/portfolio-details',
      //   allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
      //   allowedBU: ['ALL'],
      //   pageComponent: <PortfolioDetailView />,
      //   navigateState: 'metrics_master',
      //   disabled: false
      // },
      {
        pageName: 'Cycle Trigger',
        path: '/portfolio/cycle-trigger',
        allowedUserScope: [TPO_ADMIN, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <CycleTrigger />,
        navigateState: 'trigger'
      }
    ]
  },
  {
    pageName: 'Cycle Analytics',
    path: '/cycle-analytics',
    icon: <CycleAnalyticsIcon />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    subPages: [
      {
        pageName: 'Portfolio Summary',
        path: '/cycle-analytics/portfolio-details',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioDetailView />,
        navigateState: 'summary'
      },
      {
        pageName: 'Portfolio Detail View',
        path: '/cycle-analytics/portfolio-details',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioDetailView />,
        navigateState: 'detail'
      },
      {
        pageName: 'Brand Insights',
        path: '/cycle-analytics/portfolio-details',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioDetailView />,
        navigateState: 'brand'
      },
      {
        pageName: 'Portfolio Comparison',
        path: '/cycle-analytics/portfolio-details',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioDetailView />,
        navigateState: 'comparison'
      },
      {
        pageName: 'Customer Insights',
        path: '/cycle-analytics/portfolio-details',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <PortfolioDetailView />,
        navigateState: 'customer'
      }
    ]
  },
  {
    pageName: 'Alignment And Action',
    path: '/alignment-action/feedback-collation',
    icon: <AlignmentAndAction />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    subPages: [
      {
        pageName: 'Feedback & Voting',
        path: '/alignment-action/feedback-collation',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <FeedbackCollation />
      },
      {
        pageName: 'Decision Making Central',
        path: '/alignment-action/decision-making-central',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <DecisionMakingCentral />
      },
      {
        pageName: 'Cycle Action Summary',
        path: '/alignment-action/cycle-action-summary',
        allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
        allowedBU: ['ALL'],
        pageComponent: <CycleActionSummary />,
        disabled: true
      }
    ]
  },
  {
    pageName: 'Teams',
    path: '/setup-team',
    icon: <GroupOutlined sx={{ width: 22, height: 22 }} />,
    allowedUserScope: [TPO_ADMIN, GENERAL_USER, CORE_USER],
    allowedBU: ['ALL'],
    pageComponent: <SetupTeam />
  }
];

export default pages;
